export default __webpack_public_path__ + "static/media/OlivaChurchilClosed.b544c1ba.jpg";